export default (function (value) {
  var formattedValue = value; // this accounts for the case where the user backspaces through the numbers, thus deleting
  // the closing parenthesis when intending to delete the last number before it

  if (formattedValue.indexOf('(') === 0 && value.indexOf(')') === -1) {
    formattedValue = formattedValue.substring(0, formattedValue.length - 1);
  }

  formattedValue = formattedValue.replace(/\D/g, '');
  var match = formattedValue.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(.*)$/);

  if (match) {
    formattedValue = "".concat(match[1].length === 3 ? '(' : '').concat(match[1]).concat(match[1].length === 3 ? ')' : '').concat(match[2] ? ' ' : '').concat(match[2]).concat(match[3] ? '-' : '').concat(match[3]);
  }

  return formattedValue;
});